import tinycolor from 'tinycolor2';

const Getter = require('./abstract/getter');
const { isDataURL } = require('../../../../helpers/dataUrl');

module.exports = Background;

function Background () {}

Background.prototype = new Getter();
Background.prototype.constructor = Background;

Background.prototype.initialize = function () {
  Getter.prototype.initialize.call(this);

  this.editor = INKIVE.Tool.getInstance().editor;
  this.canvas = this.editor.canvas;

  this.structure = {
    color: null,
    source: null,
    background_id: null,
    background_removed: false,
    image_opacity: null,
    id: null,
    flipped: null,
    position: {
      x: null,
      y: null
    },
    size: {
      width: null,
      height: null
    }
  };
};

Background.prototype.get = function (element, attributeChain) {
  return Getter.prototype.get.call(this, $('#svgcontent > .background')[0], attributeChain);
};

Background.prototype.getColor = function () {
  const rect = $(this.element).find('rect')[0];
  const color = tinycolor(rect ? rect.getAttribute('fill') : '');
  if (!color.isValid() || !color.getAlpha()) return null;

  return color.toString();
};

Background.prototype.getSource = function () {
  const image = $(this.element).find('image')[0];
  if (!image) return null;

  const url = image.getAttribute('xlink:href');
  return isDataURL(url) ? '<data>' : url;
};

Background.prototype.getImageOpacity = function () {
  const image = $(this.element).find('image')[0];
  return image ? image.getAttribute('opacity') : null;
};

Background.prototype.getId = function () {
  return 'background';
};

Background.prototype.getFlipped = function () {
  const $image = $(this.element).find('image');
  return {
    vertical: $image.hasClass(INKIVE.C.FLIP_IMAGE.VERTICAL),
    horizontal: $image.hasClass(INKIVE.C.FLIP_IMAGE.HORIZONTAL)
  };
};

Background.prototype.getBackgroundId = function () {
  const image = $(this.element).find('image')[0];
  if (!image) return null;

  const className = image.getAttribute('class');

  if (className) {
    const match = className.match(/favourites-background-image-id-(\d+)/);
    return match && match[1];
  }
};

Background.prototype.getPositionX = function () {
  return 0;
};

Background.prototype.getPositionY = function () {
  return 0;
};

Background.prototype.getSizeWidth = function () {
  return this.canvas.contentW;
};

Background.prototype.getSizeHeight = function () {
  return this.canvas.contentH;
};

Background.prototype.getBackgroundRemoved = function () {
  const backgroundImage = document.querySelector('#svgcontent #svg_background_image');
  return backgroundImage && backgroundImage.getAttribute('data-background-removed');
};
